module.exports = __webpack_public_path__ + "static/media/main2.86778e8f.jpeg";